import { render } from "./mianPage.vue?vue&type=template&id=d381de8e"
import script from "./mianPage.vue?vue&type=script&lang=js"
export * from "./mianPage.vue?vue&type=script&lang=js"

import "./mianPage.vue?vue&type=style&index=0&id=d381de8e&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__